<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="#ac8a2e"
          inline
          title="Consulta profesional"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="jugador"
                    >
                      <v-autocomplete
                        v-model="dataForm.jugador_id"
                        color="gold"
                        :error-messages="errors"
                        label="Jugador"
                        item-value="id"
                        item-text="fullName"
                        :items="jugadores" clearable
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.fullName" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                    <v-col v-if="mode=='edit'" cols="12" md="3">
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        min-width="290px"
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider v-slot="{ errors }" name="fecha solicitud" :rules="(mode == 'new') ? 'required' : ''">
                            <v-text-field v-model="fecha_solicitud" color="gold" :error-messages="errors" label="Fecha Solicitud" readonly v-on="on" />
                          </validation-provider>
                        </template>
                        <v-tabs
                          v-model="active_tab"
                          fixed-tabs
                          color="#ac8a2e"
                        >
                          <v-tab>
                            Fecha
                          </v-tab>
                          <v-tab-item>
                            <v-date-picker
                              v-model="dataForm.fecha_solicitado"
                              color="gold"
                              landscape
                              scrollable
                              locale="es-419"
                              no-title
                              @input="active_tab = 1"
                            >
                            </v-date-picker>
                          </v-tab-item>
                          <v-tab :key=1>
                              Hora
                          </v-tab>
                            <v-tab-item>
                              <v-time-picker
                                v-model="dataForm.hora_solicitado"
                                format="ampm"
                                scrollable
                                flat
                              >
                              <v-btn text block @click="menu2 = false">
                                  Ok
                              </v-btn>
                            </v-time-picker>
                          </v-tab-item>
                        </v-tabs>
                     </v-menu>
                  </v-col>
                    <v-col cols="12" :md="mode=='edit' ? '3' : '6'">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        min-width="290px"
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider v-slot="{ errors }" name="fecha turno" rules='required'>
                            <v-text-field v-model="fecha_hora_asignado" color="gold" :error-messages="errors" label="Fecha Turno" readonly v-on="on" />
                          </validation-provider>
                        </template>
                        <v-tabs
                          v-model="active_tab"
                          fixed-tabs
                          color="#ac8a2e"
                        >
                          <v-tab>
                            Fecha
                          </v-tab>
                          <v-tab-item>
                            <v-date-picker
                              v-model="dataForm.fecha_asignado"
                              color="gold"
                              landscape
                              scrollable
                              locale="es-419"
                              no-title
                              @input="active_tab = 1"
                            >
                            </v-date-picker>
                          </v-tab-item>
                          <v-tab :key=1>
                              Hora
                          </v-tab>
                            <v-tab-item>
                              <v-time-picker
                                v-model="dataForm.hora_asignado"
                                format="ampm"
                                scrollable
                                flat
                              >
                              <v-btn text block @click="menu = false">
                                  Ok
                              </v-btn>
                            </v-time-picker>
                          </v-tab-item>
                        </v-tabs>
                     </v-menu>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="médico">
                      <v-select v-model="dataForm.medico_id" @change="setCargo" color="gold" :disabled="esMedico" :error-messages="errors" label="Profesional" item-value="id" item-text="fullName" :items="medicos" clearable>
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.fullName" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                  <validation-provider v-slot="{ errors }" name="especialidad" rules="required">
                    <v-select v-model="dataForm.especialidad_id" color="gold" :error-messages="errors" label="Especialidad" item-value="id" item-text="descripcion" :items="cargos" clearable :disabled="dataForm.medico_id ? true : false">
                      <template v-slot:item="{ attrs, item, on }">
                        <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.descripcion" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      name="descripción jugador"
                      rules="max:250"
                    >
                      <v-textarea
                        v-model="dataForm.descripcion_jugador"
                        color="#ac8a2e"
                        :error-messages="errors"
                        name="input-6-1"
                        label="Descripción jugador"
                      />
                    </validation-provider>
                  </v-col>
                    <v-col cols="12" md="6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="descripción jugador"
                        rules="max:250"
                      >
                        <v-textarea
                          v-model="dataForm.descripcion_medico"
                          color="#ac8a2e"
                          :error-messages="errors"
                          name="input-6-1"
                          label="Descripción profesional"
                        />
                      </validation-provider>
                     </v-col>
                  <v-col cols="12" class="pb-0 pt-0">
                    <v-card>
                      <v-card-title class="white">
                        <v-row>
                          <v-col cols="auto" class="pl-0 black--text">
                            <v-icon class="black--text" large>
                              mdi-file-document
                            </v-icon>
                            <span style="font-size: 115%"></span> Documentación jugador
                          </v-col>
                          <v-spacer> </v-spacer>
                          <template>
                            <v-col cols="auto" class="black--text">
                              <v-tooltip content-class="top" top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="black--text" v-bind="attrs" v-on="on" @click.stop="open(true)">
                                    mdi-plus
                                  </v-icon>
                                </template>
                                <span>Agregar</span>
                              </v-tooltip>
                            </v-col>
                          </template>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-chip-group
                          active-class="primary--text"
                          column
                        >
                          <v-chip
                            class="ma-2"
                            close
                            v-for="(item, key) in dataForm.documentosJugador" :key="key"
                            @click="openFile(item.id)"
                            @click:close="esJugador = true, eliminarChip(item.id, key)"
                          >
                            <span style="font-size: 150%"></span> {{ item.nombre }}
                          </v-chip>
                        </v-chip-group>
                      </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                  </v-col>
                    <v-col cols="12" class="pb-0 pt-0">
                      <v-card>
                        <v-card-title class="white">
                          <v-row>
                            <v-col cols="auto" class="pl-0 black--text">
                              <v-icon class="black--text" large>
                                mdi-file-document
                              </v-icon>
                              <span style="font-size: 115%"></span> Documentación profesional
                            </v-col>
                            <v-spacer> </v-spacer>
                            <template>
                              <v-col cols="auto" class="black--text">
                                <v-tooltip content-class="top" top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="black--text" v-bind="attrs" v-on="on" @click.stop="open(false)">
                                      mdi-plus
                                    </v-icon>
                                  </template>
                                  <span>Agregar</span>
                                </v-tooltip>
                              </v-col>
                            </template>
                          </v-row>
                        </v-card-title>
                        <v-card-text>
                          <v-chip-group
                            active-class="primary--text"
                            column
                          >
                            <v-chip
                              class="ma-2"
                              close
                              v-for="(item, key) in dataForm.documentosMedico" :key="key"
                              @click="openFile(item.id)"
                              @click:close="esJugador = false, eliminarChip(item.id, key)"
                            >
                              <span style="font-size: 150%"></span> {{ item.nombre }}
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  <v-col cols="12">
                    <v-row justify="end">
                      <v-btn v-if="mode !=='show'" :disabled="$disabled()" color="#ac8a2e" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
      <v-col cols="auto">
      <template>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Agregar Documentación</span>
            </v-card-title>
            <v-card-text>
              <base-upload-files folder="/documentaciones/consultas-medicas" tipo="pdf" :documento-id="documentoId" @documento="newFile = $event" />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="red"
                text
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="agregarChip"
              >
                Aceptar
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: false,
        default: 'new',
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      tittle: 'Nuevo',
      modo: '',
      menu: false,
      menu2: false,
      dialog: false,
      esMedico: false,
      esJugador: false,
      active_tab: 0,
      active_tab1: 0,
      newFile: null,
      documentoId: 0,
      medicos: [],
      jugadores: [],
      cargos: [],
      dataForm: {
        documentosJugador: [],
        documentosMedico: [],
        especialidad_id: '',
        fecha_solicitud: '',
        fecha_hora_asignado: '',
        fecha_solicitado: '',
        hora_solicitado: '',
        fecha_asignado: '',
        hora_asignado: '',
        jugador_id: '',
        medico_id: '',
        descripcion_jugador: '',
        descripcion_medico: '',
      },
    }),

    computed: {

      fecha_solicitud: function () {
        return this.dataForm.fecha_solicitado + ' ' + this.dataForm.hora_solicitado
      },

      fecha_hora_asignado: function () {
        return this.dataForm.fecha_asignado + ' ' + this.dataForm.hora_asignado
      },

    },

    created () {
      this.setTittle()
      this.getJugadores()
      this.getMedicos()
      this.getCargosMedicos()
      if (this.mode === 'edit') {
        this.getConsulta()
      }
      this.setMedico()
    },

    watch: {

      newFile (val) {
        this.documentoId = this.newFile
      },

      mode (val) {
        this.modo = this.mode
      },
    },

    methods: {

      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nueva consulta'
        }
        if (this.mode === 'edit') {
          this.tittle = 'Editar consulta'
        }
      },

      getConsulta: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/consulta_medica_get/' + this.id }).then(response => {
          this.dataForm = response
          // this.getDocJugador()
          // this.getDocMedico()
        })
      },

      getDocJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/consulta_medica_jugador_documentacion/' + this.dataForm.id }).then(response => {
          for (var a = 0; a < response.length; a++) {
            this.dataForm.documentosJugador.push(response[a])
          }
        })
      },

      getDocMedico: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/consulta_medica_medico_documentacion/' + this.dataForm.id }).then(response => {
          for (var a = 0; a < response.length; a++) {
            this.dataForm.documentosMedico.push(response[a])
          }
        })
      },

      getMedicos: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_medicos' }).then(response => { this.medicos = response })
      },

      getJugadores: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },

      getCargosMedicos: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/cargo_medico_get' }).then(response => { this.cargos = response })
      },

      setMedico: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_loged_medico' }).then(response => {
          if (response) {
            this.dataForm.medico_id = response.id
            this.dataForm.especialidad_id = response.cargo_id
            this.esMedico = true
          }
        })
      },

      setCargo: function () {
        if (this.dataForm.medico_id) {
          this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get/' + this.dataForm.medico_id }).then(response => {
            this.dataForm.especialidad_id = response.cargo_id
          })
        }
      },

      validateForm (scope) {
        this.saveConsulta()
      },

      saveConsulta: async function () {
        this.dataForm.fecha_solicitud = this.fecha_solicitud
        this.dataForm.fecha_hora_asignado = this.fecha_hora_asignado

        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/consulta_medica_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de consulta exitosa'] })
          this.$router.push({ name: 'Consultas profesionales' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
      },

      saveDocumentacion () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/files_get/' + this.documentoId }).then(response => {
          if (this.esJugador) {
            this.dataForm.documentosJugador.push(response)
          } else {
            this.dataForm.documentosMedico.push(response)
          }
        })
      },

      deleteDocumentacion: async function (id = this.documentoId) {
        await this.$http.delete('/api/files_delete/' + id)
      },

      agregarChip () {
        this.saveDocumentacion()
        this.dialog = false
      },

      eliminarChip (id, key) {
        this.deleteDocumentacion(id)
        if (this.esJugador) {
          this.$delete(this.dataForm.documentosJugador, key)
        } else {
          this.$delete(this.dataForm.documentosMedico, key)
        }
      },

      open (esJugador = false) {
        this.esJugador = esJugador
        this.dialog = true
      },

      close () {
        this.deleteDocumentacion()
        this.dialog = false
      },

      openFile (internalid) {
        this.downloadDocument(internalid, false)
      },

      downloadDocument (internalid, isPublic) {
        this.$http.get('/api/files/download/' + internalid + '/disk/' + isPublic, { responseType: 'arraybuffer' })
          .then(response => {
            this.downloadFile(response, 'documentacion')
          }, response => {
          },
          )
      },

      downloadFile (response, filename) {
        var newBlob = new Blob([response.data], { type: 'application/pdf' })
        var url = URL.createObjectURL(newBlob)
        var a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.click()
      },

    },
  }
</script>
